const getters = {
  username: (state) => state.user.username,
  token: (state) => state.user.token,
  is_principal: (state) => state.user.is_principal,
  roleList: (state) => state.user.roleList,
  permisionList: (state) => state.user.permisionList.filter(item => !item.hide),
  // permisionList: (state) => state.user.permisionList,

  adminUserName: (state) => state.user.adminUserName,
  adminToken: (state) => state.user.adminToken,
  adminpermisionList: (state) => state.user.adminpermisionList
};

export default getters;
